import { render } from "./mvt-dialogcenter.vue?vue&type=template&id=27dda0d2"
import script from "./mvt-dialogcenter.js?vue&type=script&lang=js"
export * from "./mvt-dialogcenter.js?vue&type=script&lang=js"

import "./mvt-dialogcenter.vue?vue&type=style&index=0&id=27dda0d2&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__